import { render, staticRenderFns } from "./trainingmanagement.vue?vue&type=template&id=d31bebca&scoped=true"
import script from "./trainingmanagement.vue?vue&type=script&lang=js"
export * from "./trainingmanagement.vue?vue&type=script&lang=js"
import style0 from "./trainingmanagement.vue?vue&type=style&index=0&id=d31bebca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31bebca",
  null
  
)

export default component.exports